import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAtom } from 'jotai'
import { activeWorkspaceWithStorageAtom } from '@/stores/workspaceStore'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/app-sidebar'
import { APP_NAME } from '@/lib/env'
export const Route = createFileRoute('/(protected)/')({
  component: RouteComponent,
  validateSearch: (
    search: Record<string, unknown>
  ): { token?: string; expiry?: string } => {
    // Handle native login tokens
    const { token, expiry } = search
    if (token && expiry) {
      console.log('setting token and expiry', token, expiry)
      localStorage.setItem('auth:token', token as string)
      localStorage.setItem('auth:expiry', expiry as string)
    }
    return {
      token: search?.token as string,
      expiry: search.expiry as string,
    }
  },
})

function RouteComponent() {
  const [activeWorkspace] = useAtom(activeWorkspaceWithStorageAtom)

  if (activeWorkspace) {
    const workspaceId = activeWorkspace.slug || activeWorkspace.id
    return <Navigate to={`/workspaces/${workspaceId}` as any} />
  }

  // Handle case when no workspace is active
  return (
    <SidebarProvider>
      <div className="flex h-screen">
        <AppSidebar />
        <main className="flex-1 overflow-hidden">
          <div className="h-full w-full bg-background">
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <h2 className="text-2xl font-bold mb-2">Welcome to {APP_NAME}</h2>
                <p className="text-muted-foreground">Select or create a workspace to get started</p>
              </div>
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
